import {
  Button,
  ChevronDownIcon,
  PlusIcon
} from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import styled from "styled-components";

const HeaderContainer = styled.div`
  padding: 8px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const TitleContent = styled.h1`
  flex-grow: 1;
  font-size: 1.75rem;
  margin: 0;
  line-height: 1;
`;

interface IncentivesManagerHeaderProps {
  isCreateIncentiveDisabled?: boolean;
  onAttributesClick?: () => void;
  onPreferencesClick?: () => void;
  onCreateIncentiveClick?: () => void;
}

export const IncentivesManagerHeader = ({
  isCreateIncentiveDisabled = false,
  onAttributesClick,
  onPreferencesClick,
  onCreateIncentiveClick
}: IncentivesManagerHeaderProps) => {
  return (
    <HeaderContainer>
      <TitleContent>{Locale.getText("INCENTIVES_MANAGER")}</TitleContent>
      <Button
        analyticsConfiguration={{
          eventName: ""
        }}
        buttonStyle="secondary"
        endIcon={<ChevronDownIcon title={""} />}
        onClick={onAttributesClick}
      >
        {Locale.getText("TABLE_ATTRIBUTES")}
      </Button>
      <Button
        analyticsConfiguration={{
          eventName: ""
        }}
        buttonStyle="secondary"
        onClick={onPreferencesClick}
      >
        {Locale.getText("PREFERENCES")}
      </Button>
      <Button
        analyticsConfiguration={{
          eventName: ""
        }}
        buttonStyle="primary"
        disabled={isCreateIncentiveDisabled || false}
        startIcon={<PlusIcon title={""} />}
        onClick={onCreateIncentiveClick}
      >
        {Locale.getText("CREATE_INCENTIVE")}
      </Button>
    </HeaderContainer>
  );
};
